
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Provider } from '@/types/product';

interface CompetitorsState {
  originalCompetitors: Provider[];
  availableCompetitors: Provider[];
  selectedCompetitors: Provider[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CompetitorsState = {
  originalCompetitors: [],
  availableCompetitors: [],
  selectedCompetitors: [],
  isLoading: false,
  error: null,
};

const competitorsSlice = createSlice({
  name: 'competitors',
  initialState,
  reducers: {
    setAvailableCompetitors: (state, action: PayloadAction<Provider[]>) => {
      state.originalCompetitors = action.payload;
      state.availableCompetitors = action.payload;
    },
    addSelectedCompetitor: (state, action: PayloadAction<Provider>) => {
      if (state.selectedCompetitors.length < 3) {
        state.selectedCompetitors.push(action.payload);
        state.availableCompetitors = state.originalCompetitors.filter(
          comp => !state.selectedCompetitors.some(sel => sel.id === comp.id)
        );
      }
    },
    removeSelectedCompetitor: (state, action: PayloadAction<Provider>) => {
      state.selectedCompetitors = state.selectedCompetitors.filter(
        comp => comp.id !== action.payload.id
      );
      state.availableCompetitors = state.originalCompetitors.filter(
        comp => !state.selectedCompetitors.some(sel => sel.id === comp.id)
      );
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setAvailableCompetitors,
  addSelectedCompetitor,
  removeSelectedCompetitor,
  setLoading,
  setError,
} = competitorsSlice.actions;

export default competitorsSlice.reducer;
